var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSunLounger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3542 14.8958H24.0625V49.2708H26.3542V14.8958Z",
    fill: "#CFD8DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3542 14.8958H24.0625V27.5H26.3542V14.8958Z",
    fill: "#B0BEC5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6001 43.9038L41.3085 37.0288L43.4821 36.3035L45.7738 43.1785L43.6001 43.9038ZM9.16669 43.5417V49.2709H12.6042V43.5417H9.16669ZM42.3959 43.5417V49.2709H45.8334V43.5417H42.3959Z",
    fill: "#5D4037"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1356 32.0833L46.9574 29.496C46.1611 28.5117 44.7185 28.3605 43.7342 29.1568L31.224 38.9583H8.02085C6.75471 38.9583 5.72919 39.9838 5.72919 41.25V43.5416H33.2292L35.7294 42.3958L49.1356 32.0833Z",
    fill: "#FFE0B2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72919 19.4792L25.2084 6.01562L44.6875 19.4792L33.2292 22.9167H17.1875L5.72919 19.4792Z",
    fill: "#9ECAF2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 22.9167L25.2083 6.01562L33.2292 22.9167H17.1875Z",
    fill: "#3D709B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3542 6.87501H24.0625V5.72918C24.0625 5.09668 24.5758 4.58334 25.2083 4.58334C25.8408 4.58334 26.3542 5.09668 26.3542 5.72918V6.87501Z",
    fill: "#00838F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0445 42.3959L49.2525 32.214L47.7881 30.4517L32.2896 42.3959H5.72919V44.6875H49.2709V42.3959H36.0445Z",
    fill: "#8D6E63"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunLounger);
export default __webpack_public_path__ + "static/media/sun_lounger.18b6f3c7d9b7ab934a729271497fc83e.svg";
export { ForwardRef as ReactComponent };